import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { getPhotoUrl } from '@/utils/photoUrl';
import { Eye, Pencil, Lock, Unlock, Trash2 } from "lucide-react";

function getPlayerName(player) {
  if (!player) return "-";
  if (player.first_name) return `${player.first_name} ${player.last_name}`;
  return player.name || "-";
}

function calcAverage(skills, setterSkills) {
  if (skills && Object.keys(skills).length > 0) {
    const values = Object.values(skills);
    return (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1);
  }
  if (setterSkills && Object.keys(setterSkills).length > 0) {
    const values = Object.values(setterSkills);
    return (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1);
  }
  return 0;
}

export function EvaluationRow({ 
  ev, player, evalUser, isSelected, isAdmin,
  canDeleteEvaluations, canBlockEvaluations, togglingBlockId,
  onToggleSelection, onViewDetails, onEdit, onToggleBlock, onDelete,
  formatDate, t
}) {
  const avg = calcAverage(ev.skills, ev.setter_skills);

  return (
    <tr className={`border-b border-border/40 hover:bg-muted/40 transition-colors ${ev.blocked ? 'opacity-60 bg-orange-500/5' : ''} ${isSelected ? 'bg-primary/10' : ''}`}>
      {canDeleteEvaluations && (
        <td className="px-4 py-2 text-center">
          <Checkbox checked={isSelected} onCheckedChange={() => onToggleSelection(ev.id)} className="border-muted-foreground" />
        </td>
      )}
      <td className="px-4 py-2 whitespace-nowrap">{formatDate(ev.created_at)}</td>
      <td className="px-4 py-2">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full overflow-hidden bg-muted flex items-center justify-center border border-border/60">
            {player?.photo_url ? (
              <img src={getPhotoUrl(player.photo_url)} alt={getPlayerName(player)} className="w-full h-full object-cover" />
            ) : (
              <span className="text-[10px] text-muted-foreground">Sem foto</span>
            )}
          </div>
          <div>
            <div className="font-medium">{getPlayerName(player)}</div>
            <div className="text-[10px] text-muted-foreground">{player?.position}</div>
          </div>
        </div>
      </td>
      <td className="px-4 py-2 whitespace-nowrap">{evalUser?.name || "-"}</td>
      <td className="px-4 py-2 whitespace-nowrap capitalize">{ev.profile_type || 'jogador'}</td>
      <td className="px-4 py-2 whitespace-nowrap">
        <span className={`font-semibold ${ev.blocked ? 'text-muted-foreground line-through' : ''}`}>{avg}</span>
        {ev.blocked && (
          <span className="ml-2 text-xs bg-orange-500/20 text-orange-400 px-2 py-0.5 rounded">Bloqueada</span>
        )}
      </td>
      <td className="px-4 py-2 whitespace-nowrap text-right">
        <div className="flex items-center justify-end gap-2">
          <Button variant="outline" size="sm" className="h-8 px-3" onClick={() => onViewDetails(ev)}>
            <Eye className="h-4 w-4 mr-1" /> {t('evaluationsPanel.viewDetails')}
          </Button>
          {isAdmin && (
            <Button variant="outline" size="sm" className="h-8 px-3 text-blue-400 border-blue-500/40 hover:bg-blue-500/10"
              onClick={(e) => { e.stopPropagation(); onEdit(ev); }} data-testid={`edit-evaluation-btn-${ev.id}`}>
              <Pencil className="h-4 w-4 mr-1" /> Editar
            </Button>
          )}
          {canBlockEvaluations && (
            <Button variant="ghost" size="sm"
              className={`h-8 px-2 ${ev.blocked ? 'text-green-500 hover:text-green-400 hover:bg-green-500/10' : 'text-orange-500 hover:text-orange-400 hover:bg-orange-500/10'}`}
              onClick={(e) => onToggleBlock(ev, e)} disabled={togglingBlockId === ev.id}
              title={ev.blocked ? 'Desbloquear avaliação' : 'Bloquear avaliação'}>
              {togglingBlockId === ev.id ? (
                <span className="h-4 w-4 animate-spin">&#x27F3;</span>
              ) : ev.blocked ? (
                <Unlock className="h-4 w-4" />
              ) : (
                <Lock className="h-4 w-4" />
              )}
            </Button>
          )}
          {canDeleteEvaluations && (
            <Button variant="ghost" size="sm" className="h-8 px-2 text-red-500 hover:text-red-400 hover:bg-red-500/10"
              onClick={(e) => onDelete(ev, e)}>
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </td>
    </tr>
  );
}
